"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var imagesCarousel = /*#__PURE__*/function () {
  function imagesCarousel(items, id, maxItems) {
    var _this = this;

    _classCallCheck(this, imagesCarousel);

    var self = this;
    this.items = items;
    this.id = id;
    this.maxItems = maxItems;
    this.initialized = false;
    this.carouselContainer = document.getElementById(id);
    this.carousel = this.carouselContainer.querySelector('.swiper-container');
    this.carouselWrapper = this.carousel.querySelector('.swiper-wrapper');
    this.createSlides();
    this.createCarousel();
    this.swiper = this.carousel.swiper;
    this.carouselContainer.querySelector('.close').addEventListener('click', function (e) {
      self.carouselContainer.classList.remove('open');
    });
    console.log('Modal images', this);
    this.carouselContainer.addEventListener('click', function (e) {
      if (e.target === _this.carouselContainer) {
        self.carouselContainer.classList.remove('open');
      }
    });
  }

  _createClass(imagesCarousel, [{
    key: "createSlides",
    value: function createSlides() {
      for (var i = 0; i < this.maxItems; i++) {
        var item = this.items[i];
        this.createSlide(item);
      }
    }
  }, {
    key: "createSlide",
    value: function createSlide(itemData) {
      var imgUrl = itemData.filename;
      var slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      var modalImageWrapper = document.createElement('div');
      modalImageWrapper.classList.add('modal-image-picture-wrapper');
      var image = document.createElement('img');
      image.classList.add('modal-image-picture');
      image.setAttribute('data-src', '../assets/images/photos/' + imgUrl);
      image.classList.add('swiper-lazy');
      modalImageWrapper.appendChild(image);
      var name = document.createElement('div');
      name.classList.add('modal-image-worker-name');
      name.innerHTML = itemData.name;
      var place = document.createElement('div');
      place.classList.add('modal-image-worker-place');
      place.innerHTML = itemData.place;
      var job = document.createElement('div');
      job.classList.add('modal-image-worker-job');
      job.innerHTML = itemData.jobTitle; // Preloader.

      var lazy_preloader = document.createElement('div');
      lazy_preloader.classList.add('swiper-lazy-preloader');
      slide.appendChild(lazy_preloader);
      slide.appendChild(modalImageWrapper);
      slide.appendChild(name);
      slide.appendChild(place);
      slide.appendChild(job);
      this.carouselWrapper.appendChild(slide);
    }
  }, {
    key: "createCarousel",
    value: function createCarousel() {
      var self = this;
      new Swiper(this.carousel, {
        loop: false,
        speed: 500,
        threshold: 20,
        lazy: true,
        // If we need pagination
        pagination: {
          el: self.carouselContainer.querySelector('.swiper-pagination')
        },
        navigation: {
          nextEl: self.carouselContainer.querySelector('.swiper-button-next'),
          prevEl: self.carouselContainer.querySelector('.swiper-button-prev')
        },
        on: {
          init: function init() {
            self.initialized = true;
          },
          slideChangeTransitionStart: function slideChangeTransitionStart() {
            if (self.initialized === true) {}
          }
        }
      });
    }
  }]);

  return imagesCarousel;
}();
"use strict";

document.addEventListener('DOMContentLoaded', function (event) {
  axios('../assets/json/' + appLanguage + '/video-portraits.json?=18dec').then(function (response) {
    if (response) {
      new videosGrid(response.data, 'video-grid--container', function () {
        new videosCarousel(response.data, 'video-grid--modal');
      }, 0, 15, null, true);
    }
  })["catch"](function (error) {
    // handle error
    console.log(error);
  });
  /*axios('../assets/json/' + appLanguage + '/video-grid--one.json').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--one-container', () => {
          new videosCarousel(response.data, 'video-grid--one-modal', 15)
        }, 0, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })
   axios('../assets/json/' + appLanguage + '/video-grid--two.json').
    then(function (response) {
      if (response) {
        new videosGrid(response.data, 'video-grid--two-container', () => {
          new videosCarousel(response.data, 'video-grid--two-modal', 15)
        }, 0, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })
   axios('../assets/json/' + appLanguage + '/image-grid--one.json').
    then(function (response) {
      if (response) {
        new imagesGrid(response.data, 'image-grid--one', () => {
          new imagesCarousel(response.data, 'image-grid--one-modal', 15)
        },0, 15, 15)
      }
    }).catch(function (error) {
    // handle error
    console.log(error)
  })*/
});
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var imagesGrid = /*#__PURE__*/function () {
  function imagesGrid(items, id) {
    var completeCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var autoplay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var itemsPerSlide = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 15;
    var maxItems = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 45;

    _classCallCheck(this, imagesGrid);

    this.items = items;
    this.id = id;
    this.itemsPerSlide = itemsPerSlide;
    this.maxItems = maxItems;
    this.autoplay = autoplay; // Carousel.

    this.imgGridContainer = document.getElementById(this.id);
    this.imgGrid = this.imgGridContainer.querySelector('.swiper-container');
    this.imgGridWrapper = this.imgGrid.querySelector('.swiper-wrapper'); // Modal.

    var modalId = this.imgGridContainer.getAttribute('data-modal');
    this.modal = document.getElementById(modalId); // Start.

    this.calculateMaxItems(); // this.shuffleArray()

    this.createSlides();
    this.createCarousel();

    if (completeCallback) {
      completeCallback();
    }
  }

  _createClass(imagesGrid, [{
    key: "calculateMaxItems",
    value: function calculateMaxItems() {
      var w = window.innerWidth;

      if (w <= 1023) {
        this.maxItems = this.maxItems > 30 ? 30 : this.maxItems;
      } else {
        this.maxItems = this.maxItems > 45 ? 45 : this.maxItems;
      }

      this.maxItems = this.maxItems > this.items.length ? this.items.length : this.maxItems;
    }
  }, {
    key: "createSlides",
    value: function createSlides() {
      var slide = null;

      for (var i = 0; i < this.maxItems; i++) {
        var item = this.items[i];

        if (i % this.itemsPerSlide === 0) {
          slide = this.createSlide();
        }

        this.createItem(slide, item, i);
      }
    }
  }, {
    key: "createSlide",
    value: function createSlide() {
      var slide = document.createElement('div');
      slide.classList.add('img-grid--slide');
      slide.classList.add('swiper-slide'); // Preloader.
      // let lazy_preloader = document.createElement('div')
      // lazy_preloader.classList.add('swiper-lazy-preloader')
      // slide.appendChild(lazy_preloader)

      this.imgGridWrapper.appendChild(slide);
      return slide;
    }
  }, {
    key: "createItem",
    value: function createItem(slide, itemData, index) {
      if (!itemData) {
        return;
      }

      var self = this,
          imgUrl = itemData.filename,
          name = itemData.name,
          location = itemData.place,
          profession = itemData.jobTitle;
      /**
       * Grid item.
       * @type {HTMLDivElement}
       */

      var container = document.createElement('div');
      container.classList.add('image-grid--item');
      container.setAttribute('data-img', imgUrl);
      container.setAttribute('data-name', name);
      container.setAttribute('data-location', location);
      container.setAttribute('data-profession', profession);
      container.setAttribute('data-index', index);
      container.addEventListener('click', function (e) {
        self.modal.classList.add('open');
        self.modal.querySelector('.swiper-container').swiper.update();
        self.modal.querySelector('.swiper-container').swiper.slideTo(index, 0);
        console.log('Open', self.modal.querySelector('.swiper-container').swiper);
      });
      /**
       * Image.
       * @type {HTMLImageElement}
       */

      var dir = '../assets/images/photos/small/';
      var itemImageWrapper = document.createElement('div');
      itemImageWrapper.classList.add('img-grid--item-image-wrapper');
      var item = document.createElement('img');
      item.setAttribute('data-src', '../assets/images/photos/small/' + imgUrl);
      item.classList.add('swiper-lazy');
      itemImageWrapper.style.backgroundImage = 'url(' + dir + imgUrl + ')'; // itemImageWrapper.appendChild(item)

      /**
       * Details.
       * @type {HTMLDivElement}
       */

      var itemDetailsContainer = document.createElement('div');
      itemDetailsContainer.classList.add('img-grid--item-details');
      var itemName = document.createElement('div');
      itemName.classList.add('img-grid--item-name');
      itemName.textContent = name;
      var itemLocation = document.createElement('div');
      itemLocation.classList.add('img-grid--item-location');
      itemLocation.textContent = location;
      var itemProfession = document.createElement('div');
      itemProfession.classList.add('img-grid--item-profession');
      itemProfession.textContent = profession;
      itemDetailsContainer.appendChild(itemName);
      itemDetailsContainer.appendChild(itemLocation);
      itemDetailsContainer.appendChild(itemProfession);
      /**
       * Add to DOM.
       */

      container.appendChild(itemImageWrapper);
      container.appendChild(itemDetailsContainer);
      slide.appendChild(container);
    }
  }, {
    key: "createCarousel",
    value: function createCarousel() {
      var self = this;
      new Swiper(this.imgGrid, {
        loop: self.items.length / self.itemsPerSlide > 1,
        slidesPerView: 1,
        centeredSlides: true,
        speed: 500,
        threshold: 100,
        lazy: true,
        autoplay: self.autoplay > 0 ? {
          delay: self.autoplay
        } : undefined,
        // If we need pagination
        pagination: {
          el: self.imgGridContainer.querySelector('.swiper-pagination')
        },
        navigation: {
          nextEl: self.imgGridContainer.querySelector('.swiper-button-next'),
          prevEl: self.imgGridContainer.querySelector('.swiper-button-prev')
        },
        watchOverflow: true,
        on: {
          init: function init() {
            self.swiper = this;
            self.initialized = true;
          },
          slideChange: function slideChange() {
            self.swiper = this;
          },
          slideChangeTransitionStart: function slideChangeTransitionStart() {
            self.swiper = this;

            if (self.initialized === true) {//self.gridAnim()
            }
          }
        },
        breakpoints: {
          768: {
            // slidesPerView: 1.25, (if more than 1 slide)
            slidesPerView: self.items.length / self.itemsPerSlide > 1 ? 1.25 : 1.1
          }
        }
      });
    }
  }]);

  return imagesGrid;
}();
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var videosCarousel = /*#__PURE__*/function () {
  function videosCarousel(items, id) {
    var _this = this;

    var maxItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, videosCarousel);

    var self = this;
    this.items = items;
    this.id = id;
    this.maxItems = maxItems ? maxItems : this.items.length;
    this.initialized = false;
    this.carouselContainer = document.getElementById(id);
    this.carousel = this.carouselContainer.querySelector('.swiper-container');
    this.carouselWrapper = this.carousel.querySelector('.swiper-wrapper');
    this.createSlides();
    this.createCarousel();
    this.swiper = this.carousel.swiper; //this.swiper.init()
    // Stop embed video when closing the modal.

    this.carouselContainer.querySelector('.close').addEventListener('click', function (e) {
      self.resetAllVideos(self.swiper);
    });
    this.carouselContainer.addEventListener('click', function (e) {
      if (e.target === _this.carouselContainer) {
        self.carouselContainer.classList.remove('open');
        self.resetAllVideos(self.swiper);
      }
    });
  }

  _createClass(videosCarousel, [{
    key: "createSlides",
    value: function createSlides() {
      for (var i = 0; i < this.maxItems; i++) {
        var item = this.items[i];
        this.createSlide(item);
      }
    }
  }, {
    key: "createSlide",
    value: function createSlide(itemData) {
      var videoUrl = 'https://player.vimeo.com/video/' + itemData.vimeoId;
      var slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      var video = document.createElement('div');
      video.classList.add('modal-worker-video');
      video.setAttribute('data-videourl', videoUrl);
      video.innerHTML = this.getVideoEmbedMarkup(videoUrl);
      var name = document.createElement('div');
      name.classList.add('modal-worker-name');
      name.innerHTML = itemData.name;
      var place = document.createElement('div');
      place.classList.add('modal-worker-place');
      place.innerHTML = itemData.place;
      var job = document.createElement('div');
      job.classList.add('modal-worker-job');
      job.innerHTML = itemData.jobTitle;
      var quote = document.createElement('div');
      quote.classList.add('modal-worker-quote');
      quote.innerHTML = '<p>' + itemData.quote + '</p>';
      var watchFullVideo = document.createElement('div');
      watchFullVideo.classList.add('modal-worker-watch-full');
      watchFullVideo.innerHTML = '<a href="' + itemData.fullVideoUrl + '" target="_blank">' + fullVideoLabel + '</a>';
      slide.appendChild(video);
      slide.appendChild(name);
      slide.appendChild(place);
      slide.appendChild(job);
      slide.appendChild(quote);
      slide.appendChild(watchFullVideo);
      this.carouselWrapper.appendChild(slide);
    }
  }, {
    key: "createCarousel",
    value: function createCarousel() {
      var self = this;
      new Swiper(this.carousel, {
        loop: false,
        speed: 500,
        threshold: 20,
        // If we need pagination
        pagination: {
          el: self.carouselContainer.querySelector('.swiper-pagination')
        },
        navigation: {
          nextEl: self.carouselContainer.querySelector('.swiper-button-next'),
          prevEl: self.carouselContainer.querySelector('.swiper-button-prev')
        },
        on: {
          init: function init() {
            self.initialized = true;
          },
          slideChangeTransitionStart: function slideChangeTransitionStart() {
            if (self.initialized === true) {
              self.resetPreviousVideo(this);
              self.playVideo(this);
            }
          }
        }
      });
    }
  }, {
    key: "getVideoEmbedMarkup",
    value: function getVideoEmbedMarkup(videoUrl) {
      var autoplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return '<iframe src="' + videoUrl + '?loop=0&autopause=0&texttrack=' + appLanguage + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    }
  }, {
    key: "playVideo",
    value: function playVideo(swiper) {
      var slides = swiper.slides,
          currentSlide = slides[swiper.activeIndex],
          video = currentSlide.querySelector('.modal-worker-video'),
          iframe = video.querySelector('iframe');

      if (iframe) {
        var player = new Vimeo.Player(iframe);
        player.setCurrentTime(0);
        player.play();
      }
    }
  }, {
    key: "resetAllVideos",
    value: function resetAllVideos(swiper) {
      var slides = swiper.slides;

      for (var i = 0; i < slides.length; i++) {
        var currentSlide = slides[i],
            video = currentSlide.querySelector('.modal-worker-video'),
            iframe = video.querySelector('iframe');
        this.stopVideo(iframe);
      }
    }
  }, {
    key: "resetPreviousVideo",
    value: function resetPreviousVideo(swiper) {
      var previousIndex = swiper.previousIndex,
          currentSlide = swiper.slides[previousIndex],
          video = currentSlide.querySelector('.modal-worker-video'),
          iframe = video.querySelector('iframe');
      this.stopVideo(iframe);
    }
  }, {
    key: "stopVideo",
    value: function stopVideo(iframe) {
      if (iframe) {
        var player = new Vimeo.Player(iframe);
        player.setCurrentTime(0);
        player.pause();
      }
    }
  }]);

  return videosCarousel;
}();
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var videosGrid = /*#__PURE__*/function () {
  function videosGrid(items, id) {
    var _this = this;

    var completeCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var autoplay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var itemsPerSlide = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 15;
    var maxItems = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var showQuote = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    _classCallCheck(this, videosGrid);

    this.swiper = null;
    this.autoplay = autoplay;
    this.id = id;
    this.itemsPerSlide = itemsPerSlide;
    this.items = items;
    this.maxItems = maxItems ? maxItems : this.items.length;
    this.loadedItems = 0;
    this.initialized = false;
    this.videosLoaded = false;
    this.gridItemTL = null;
    this.intervalHighlight = null;
    this.showQuote = showQuote; // Carousel.

    this.videoGridContainer = document.getElementById(this.id);
    this.videoGrid = this.videoGridContainer.querySelector('.swiper-container');
    this.videoGridWrapper = this.videoGrid.querySelector('.swiper-wrapper'); // Modal.

    var modalId = this.videoGridContainer.getAttribute('data-modal');
    this.modal = document.getElementById(modalId); // Open modal when clicking on a preview.

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('video-grid--item')) {
        var item = e.target,
            index = item.getAttribute('data-index'); // Play preview.

        self.gridPause(self.swiper);
        self.modal.classList.add('open');
        self.modal.querySelector('.swiper-container').swiper.update();
        self.modal.querySelector('.swiper-container').swiper.slideTo(index, 0);
        self.modal.querySelector('.close').addEventListener('click', function (e) {
          self.modal.classList.remove('open');
          self.gridPlay(self.swiper);
        });
      }
    }); // Start.

    this.calculateMaxItems(); // this.shuffleArray()

    this.createSlides();
    this.createCarousel();

    if (completeCallback) {
      completeCallback();
    }

    var self = this; // Pause/Play grid videos on exit/enter grid.

    window.addEventListener('scroll', function (e) {
      var isVisible = self.isScrolledIntoView(_this.videoGrid);

      if (isVisible === true && self.swiper) {
        self.gridPlay();
      } else if (isVisible === false && self.swiper) {
        self.gridPause();
        var modalCloseButton = self.modal.querySelector('.close');
        modalCloseButton.click();
      }
    }); // Pause grid on blur.

    ifvisible.on('blur', function () {
      self.gridPause();
    }); // Restart grid on focus.

    ifvisible.on('focus', function () {
      self.gridPlay();
    }); // Pause grid on idle.

    ifvisible.on('idle', function () {
      self.gridPause();
    }); // Restart grid on Wakup.

    ifvisible.on('wakeup', function () {
      self.gridPlay();
    });
  }

  _createClass(videosGrid, [{
    key: "calculateMaxItems",
    value: function calculateMaxItems() {
      this.maxItems = this.maxItems > this.items.length ? this.items.length : this.maxItems;
    }
  }, {
    key: "createSlides",
    value: function createSlides() {
      var slide = null;

      for (var i = 0; i < this.maxItems; i++) {
        var item = this.items[i];

        if (i % this.itemsPerSlide === 0) {
          slide = this.createSlide();
        }

        this.createItem(slide, item, i);
      }
    }
  }, {
    key: "createSlide",
    value: function createSlide() {
      var slide = document.createElement('div');
      slide.classList.add('video-grid--slide');
      slide.classList.add('swiper-slide');
      this.videoGridWrapper.appendChild(slide);
      return slide;
    }
  }, {
    key: "createItem",
    value: function createItem(slide, itemData, index) {
      var self = this,
          videoUrl = 'https://player.vimeo.com/video/' + itemData.vimeoId,
          vimeoId = itemData.vimeoId,
          name = itemData.name,
          location = itemData.place,
          profession = itemData.jobTitle,
          quoteBig = itemData.quote;
      /**
       * Grid item.
       * @type {HTMLDivElement}
       */

      var container = document.createElement('div');
      container.classList.add('video-grid--item');
      container.setAttribute('data-video', videoUrl);
      container.setAttribute('data-quote', quoteBig);
      container.setAttribute('data-name', name);
      container.setAttribute('data-location', location);
      container.setAttribute('data-profession', profession);
      container.setAttribute('data-index', index);
      /**
       * Video.
       * @type {HTMLVideoElement}
       */

      var item = document.createElement('video');
      item.setAttribute('autoplay', 'true');
      item.setAttribute('muted', 'true');
      item.setAttribute('playsinline', 'true');
      item.setAttribute('loop', 'true');
      item.setAttribute('data-preview', vimeoId);
      item.setAttribute('preload', 'none');
      item.setAttribute('poster', '../assets/previews_thumbnails/' + itemData.vimeoId + '.jpg');
      item.muted = true;
      item.autoplay = false;
      item.addEventListener('loadeddata', function (e) {
        self.loadedItems++;

        if (self.loadedItems === self.maxItems) {
          self.videosLoaded = true;
        }
      });
      var itemSource = document.createElement('source');
      itemSource.setAttribute('src', '../assets/previews/' + vimeoId + '.mp4');
      item.appendChild(itemSource);
      /**
       * Details.
       * @type {HTMLDivElement}
       */

      var itemDetailsContainer = document.createElement('div');
      itemDetailsContainer.classList.add('video-grid--item-details');
      var itemName = document.createElement('div');
      itemName.classList.add('video-grid--item-name');
      itemName.textContent = name;
      var itemLocation = document.createElement('div');
      itemLocation.classList.add('video-grid--item-location');
      itemLocation.textContent = location;
      var itemProfession = document.createElement('div');
      itemProfession.classList.add('video-grid--item-profession');
      itemProfession.textContent = profession;
      itemDetailsContainer.appendChild(itemName);
      itemDetailsContainer.appendChild(itemLocation);
      itemDetailsContainer.appendChild(itemProfession);
      /**
       * Add to DOM.
       */

      container.appendChild(item);
      container.appendChild(itemDetailsContainer);
      slide.appendChild(container);
    }
  }, {
    key: "createCarousel",
    value: function createCarousel() {
      var self = this;
      new Swiper(this.videoGrid, {
        loop: self.items.length / self.itemsPerSlide > 1,
        slidesPerView: 1,
        centeredSlides: true,
        speed: 500,
        threshold: 100,
        autoplay: self.autoplay > 0 ? {
          delay: self.autoplay
        } : undefined,
        // If we need pagination
        pagination: {
          el: self.videoGridContainer.querySelector('.swiper-pagination')
        },
        navigation: {
          nextEl: self.videoGridContainer.querySelector('.swiper-button-next'),
          prevEl: self.videoGridContainer.querySelector('.swiper-button-prev')
        },
        watchOverflow: true,
        on: {
          init: function init() {
            self.swiper = this;
            introAnim();
            quoteModuleAnim();
            self.gridAnim();
            self.initialized = true;
          },
          slideChange: function slideChange() {
            self.swiper = this; // Stop previous preview.

            var previousIndex = self.swiper.previousIndex,
                previousSlide = self.swiper.slides[previousIndex],
                previousGridItems = previousSlide.getElementsByClassName('video-grid--item'),
                previousTotalItems = previousGridItems.length;

            for (var gridItemsIndex = 0; gridItemsIndex < previousTotalItems; gridItemsIndex++) {
              var gridItem = previousGridItems[gridItemsIndex];
              var gridItemPreview = gridItem.querySelector('video');
              gridItemPreview.pause();
            }
          },
          slideChangeTransitionStart: function slideChangeTransitionStart() {
            self.swiper = this;

            if (self.initialized === true) {
              self.gridAnim();
            }
          }
        },
        breakpoints: {
          768: {
            // slidesPerView: 1.1 --- 1.25, (if more than 1 slide)
            slidesPerView: 1.25
          }
        }
      });
    }
  }, {
    key: "gridAnimReset",
    value: function gridAnimReset() {
      var prevSlide = this.videoGridWrapper.querySelector('.swiper-slide-prev');

      if (prevSlide) {
        var prevGridItems = prevSlide.querySelectorAll('.video-grid--item');
        TweenMax.to(prevGridItems, 1, {
          opacity: 0.45,
          ease: 'power4.out'
        });
      }

      var nextSlide = this.videoGridWrapper.querySelector('.swiper-slide-next');

      if (nextSlide) {
        var nextGridItems = nextSlide.querySelectorAll('.video-grid--item');
        TweenMax.to(nextGridItems, 1, {
          opacity: 0.45,
          ease: 'power4.out'
        });
      }
    }
  }, {
    key: "gridAnim",
    value: function gridAnim() {
      var self = this;
      this.removeHighlight(self.swiper, self.swiper.previousIndex);
      this.gridAnimReset();
      this.gridItemTL = gsap.timeline({
        onComplete: function onComplete() {
          self.populateGrid(self.swiper);
        }
      });
      var index = self.swiper.activeIndex,
          activeSlide = self.swiper.slides[index],
          activeGridItems = activeSlide.querySelectorAll('.video-grid--item'),
          swiperButtonsPrev = self.videoGridWrapper.querySelector('.swiper-button-prev'),
          swiperButtonsNext = self.videoGridWrapper.querySelector('.swiper-button-next');
      this.gridItemTL.to(self.videoGridWrapper, {
        opacity: 1,
        duration: 1,
        ease: 'power4.out'
      }).staggerFromTo(activeGridItems, .75, {
        opacity: 0.25
      }, {
        opacity: 1,
        ease: 'power4.out'
      }, 0.1, '>+.5').to(swiperButtonsPrev, {
        opacity: 1,
        x: 0,
        duration: .25,
        ease: 'power4.out'
      }).to(swiperButtonsNext, {
        opacity: 1,
        x: 0,
        duration: .25,
        ease: 'power4.out'
      }, '>-.25');
    }
  }, {
    key: "removeHighlight",
    value: function removeHighlight(index) {
      var currentSlide = this.swiper.slides[index];

      if (currentSlide) {
        var gridItems = currentSlide.getElementsByClassName('video-grid--item');

        for (var i = 0; i < gridItems.length; i++) {
          gridItems[i].classList.remove('highlighted');
        }
      }
    }
  }, {
    key: "isScrolledIntoView",
    value: function isScrolledIntoView(el) {
      var partial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom; // Partially visible elements return true:

      var isVisible = elemTop < window.innerHeight && elemBottom >= 0; // Only completely visible elements return true:

      if (partial === false) {
        isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
      }

      return isVisible;
    }
  }, {
    key: "highlightItem",
    value: function highlightItem(currentSlide, index) {
      var gridItems = currentSlide.getElementsByClassName('video-grid--item'),
          totalGridItems = gridItems.length,
          highlightIndex = index + 1; // remove + 1 for random
      // For linear

      if (highlightIndex >= totalGridItems) {
        highlightIndex = 0;
      } // For random

      /*while (highlightIndex === index) {
        highlightIndex = Math.floor(Math.random() * totalGridItems)
      }*/


      var gridItem = gridItems[highlightIndex];

      if (gridItem) {
        gridItem.classList.add('highlighted');
        var quoteContainer = document.getElementById('worker-quote--container'),
            quoteBig = gridItem.getAttribute('data-quote'),
            name = gridItem.getAttribute('data-name'),
            location = gridItem.getAttribute('data-location'),
            profession = gridItem.getAttribute('data-profession');

        if (quoteContainer) {
          quoteContainer.classList.remove('visible');
          quoteContainer.querySelector('#worker_quote').innerHTML = quoteBig;
          quoteContainer.querySelector('#quote_worker_name').innerHTML = name;
          quoteContainer.querySelector('#quote_worker_location').innerHTML = location;
          quoteContainer.querySelector('#quote_worker_profession').innerHTML = profession;
          setTimeout(function () {
            quoteContainer.classList.add('visible');
          }, 500);
        }
      }

      return highlightIndex;
    }
  }, {
    key: "gridPause",
    value: function gridPause() {
      var index = this.swiper.activeIndex,
          currentSlide = this.swiper.slides[index],
          gridItems = currentSlide.getElementsByClassName('video-grid--item'),
          totalGridItems = gridItems.length; // Play preview.

      for (var gridItemsIndex = 0; gridItemsIndex < totalGridItems; gridItemsIndex++) {
        var gridItem = gridItems[gridItemsIndex];
        var gridItemPreview = gridItem.querySelector('video');
        gridItemPreview.pause();
      }
    }
  }, {
    key: "gridPlay",
    value: function gridPlay() {
      var index = this.swiper.activeIndex,
          currentSlide = this.swiper.slides[index],
          gridItems = currentSlide.getElementsByClassName('video-grid--item'),
          totalGridItems = gridItems.length; // Play preview.

      for (var gridItemsIndex = 0; gridItemsIndex < totalGridItems; gridItemsIndex++) {
        var gridItem = gridItems[gridItemsIndex];
        var gridItemPreview = gridItem.querySelector('video');
        gridItemPreview.play();
      }
    }
  }, {
    key: "populateGrid",
    value: function populateGrid() {
      var _this2 = this;

      var self = this,
          index = self.swiper.activeIndex,
          currentSlide = self.swiper.slides[index],
          highlightIndex = -1; // Play preview.

      this.gridPlay(); // Highlight periodically.

      if (this.showQuote) {
        if (this.intervalHighlight) {
          clearInterval(this.intervalHighlight);
        }

        setTimeout(function () {
          self.removeHighlight(index);
          highlightIndex = self.highlightItem(currentSlide, highlightIndex);
        }, 1000);
        setTimeout(function () {
          _this2.intervalHighlight = setInterval(function () {
            self.removeHighlight(index);
            highlightIndex = self.highlightItem(currentSlide, highlightIndex);
          }, 10000);
        }, 10);
      }
    }
  }, {
    key: "shuffleArray",
    value: function shuffleArray() {
      for (var i = this.items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * i);
        var temp = this.items[i];
        this.items[i] = this.items[j];
        this.items[j] = temp;
      }
    }
  }]);

  return videosGrid;
}();